export const GET_STUDENT = "GET_STUDENT";